import { ProfileService } from 'client/services';

export const loaderWithAuth = async () => {
    const [
        feedbackActivityTypes
    ] = await Promise.all([
        ProfileService.getFeedbackActivityTypes()
    ]);
    return { feedbackActivityTypes };
};
